<template>
  <div class="tab-content">
    <el-table :data="custom_data" :header-cell-style="{ color: 'black' }" v-loading="show_loading">
      <!-- 项目 -->
      <el-table-column prop="category" label="项目" align="center" width="300">
      </el-table-column>

      <!-- 系统现存资料 -->
      <el-table-column prop="file_name" label="系统现存资料" align="center" width="300">
      </el-table-column>

      <!-- 文档路径 -->
      <el-table-column prop="file_path" label="文档路径" align="center" :min-width="280" :max-width="600">
      </el-table-column>

      <!-- AI解析结果 -->
      <el-table-column prop="analysis" label="AI解析结果" align="center" width="300">
      </el-table-column>

    </el-table>
  </div>

</template>

<script>

export default {
  emits: ['switch-tab'],
  data() {
    return {
      custom_data: [],
      show_loading: false
    };
  },

  methods: {
    // 定义一个函数来调用API
    async callApi(endpoint, options = {}) {
      try {
        const response = await fetch(endpoint, options);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        throw error;
      }
    },

    async analyzeCustomData(user_id, file_name, file_path) {
      try {
        const data = await this.callApi('http://localhost:8081/demo/analyze/custom-data', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user_id: user_id,
            file_name: file_name,
            file_path: file_path,
          })
        });
        console.log('Success:', data);
        return data
      } catch (error) {
        console.error('Error during POST request:', error);
      }
    },

    async getCustomData(user_id) {
      const res = {}
      const url = new URL('http://localhost:8081/custom-data');
      url.search = new URLSearchParams({
        user_id: user_id,
      }).toString();
      await this.callApi(url)
          .then(data => {
            console.log('Data fetched successfully:', data);
            data = data[0]
            res.user_id = data.user_id;
            res.category = data.category;
            res.file_name = data.file_name;
            res.file_path = data.file_path;
            res.analysis = data.analysis;
          })
          .catch(error => {
            console.error('Failed to fetch data:', error);
          });

      if (res.analysis === null || res.analysis === '') {
        await this.analyzeCustomData(res.user_id, res.file_name, res.file_path)
            .then(data => {
              res.analysis = data;
            })
            .catch(error => {
              console.error('Failed to analyzeCustomData:', error);
            });
      }

      this.custom_data.push(res);
    },

  },

  mounted() {
    // 从登录信息获取
    const user_id = 10086
    this.getCustomData(user_id);
  }
};
</script>

<style scoped>
.file-path {

}
</style>